export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料网站</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的社会热点深度报道与内幕资讯聚合平台，提供黑料网站入口、黑料官网及黑料网最新入口，日更新大量独家爆料资讯。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-telegram-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <div className="space-y-2.5">
              <a href="#carousel" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#index" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">网址导航</a>
              <a href="#topics" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热点话题</a>
              <a href="#ranking" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门排行</a>
              <a href="#updates" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新动态</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">帮助与联系</h3>
            <div className="space-y-2.5">
              <a href="#faq" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              <a href="#features" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">平台优势</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <div className="space-y-2">
              <p className="text-sm text-background-500">合作伙伴信息即将更新，敬请期待。</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 黑料网站 版权所有 | 黑料网站入口 - 黑料网官网 - 黑料网最新网址
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}